/**
 * @module utils
 * @private
 */
export async function getPlaybackTokenRequestBody(config) {
  const requestBody = {
    releasePids: config.releasePids,
    protectionScheme: this.drmTechnology
  };
  (await this.device.supports4K()) &&
    config.has4K &&
    Object.assign(requestBody, { Securitylevel: this.securitylevel4K });

  return requestBody;
}
